import React, { memo, useEffect, useRef } from 'react'

import { LatLng } from 'types'
import { darkModeStyle } from 'components/DarkModeLoader/googleMapsDark'

import { GoogleMap, useLoadScript, Marker } from '@react-google-maps/api'
import { interWbSession } from '@interco/inter-webview-bridge'

interface Props {
  userLocation: LatLng
}

const Maps: React.FC<Props> = ({ userLocation }) => {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY ?? '',
  })

  const isDark = useRef(false)

  const handleDarkMode = async () => {
    const appInfo = await interWbSession.getAppInfo()
    if (appInfo.isDarkMode) isDark.current = true
    return {}
  }

  const darkModeMaps = useRef(darkModeStyle)

  const containerStyle = {
    width: '100%',
    height: '80dvh',
  }

  const mapOptions = {
    fullscreenControl: false,
    mapTypeControl: false,
    minZoom: 13,
    streetViewControl: false,
    clickableIcons: false,
    styles: isDark.current ? darkModeMaps.current : null,
  }

  useEffect(() => {
    handleDarkMode()
  }, [])

  if (loadError) {
    return <div>Map cannot be loaded right now, sorry.</div>
  }

  const userLocationMarker = userLocation && <Marker position={userLocation} />

  return (
    isLoaded && (
      <GoogleMap
        options={mapOptions}
        mapContainerStyle={containerStyle}
        center={userLocation}
        zoom={18}
      >
        {userLocationMarker}
      </GoogleMap>
    )
  )
}

export default memo(Maps)
